module.exports = __webpack_public_path__ + "img/support.b8ecc23f.svg";